






import {
    Vue, Component, Prop, Mixins,
} from 'vue-property-decorator'

@Component
export default class CopyButton extends Vue {
    @Prop({default: ''}) text!: string

    @Prop({default: false}) showToast!: boolean

    copyText() {
        let copyInput
        if (document.getElementsByClassName('copyInputComponent').length > 0) {
            copyInput = document.getElementsByClassName('copyInputComponent')[0]
        } else {
            copyInput = document.createElement('input')
            copyInput.className = 'copyInputComponent'
            document.body.appendChild(copyInput)
        }
        copyInput.value = this.text
        copyInput.select()
        document.execCommand('Copy')
        if (!this.showToast) {
            this.$message.success(this.$t1('copy_success'))
        } else {
            this.$emit('copySuccess')
        }
        if (copyInput) {
            document.body.removeChild(copyInput)
        }
    }
}
